<template>
  <div class="admin-list">
    <div
      class="admin-list__item"
      v-for="(admin, i) in admins"
      :key="admin.name + i"
      @click="selectAdmin(admin)"
    >
      <div class="admin-list__info">
        <div class="admin-list__photo">
          <span class="admin-list__acronym"
            >{{ profileAcronym(admin.name) }}
          </span>
          <status-dot class="admin-list__status" />
        </div>
        <div class="admin-list__admin-info">
          <span class="admin-list__name">
            {{ admin.name }}
          </span>
          <span class="admin-list__email">
            {{ admin.email }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusDot from '@/components/shared/HccStatusDot/index.vue';

export default {
  components: {
    StatusDot,
  },
  props: {
    admins: {
      type: Array,
      required: true,
    },
  },
  methods: {
    profileAcronym(name) {
      return name.substr(0, 1);
    },
    selectAdmin(admin) {
      this.$emit('select-admin', admin);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/chatButton/_chat-button.scss";
</style>
